import React from "react";

import type { ProcessedPickemSelection } from "@/hooks/firestore/betting/useEntries";

import { Clamp } from "@picklebet/ui";
import { Countdown } from "@/features/shell/components/shared/Countdown";
import { LiveClampWithStream } from "../common/LiveClampWithStream";
import { WinCelebration } from "../common/WinCelebration";

interface PickClampProps {
  selection: ProcessedPickemSelection;
  isEntryWon?: boolean;
}

const PickClamp = ({ selection, isEntryWon }: PickClampProps) => {
  const replacedPick = selection?.replacementOutcome;
  const validPick = replacedPick ?? selection;

  const hasResult = selection.result !== "UNDECIDED";
  const isLive = selection.marketStatus === "DEACTIVATED";

  return (
    <>
      {hasResult && (
        <Clamp variant={validPick.result === "WIN" ? "success" : "neutral"}>
          <WinCelebration
            isEnabled={Boolean(validPick.result === "WIN" && isEntryWon)}
          >
            {!validPick?.competitor?.scratched ? validPick.result : "SCRATCHED"}
          </WinCelebration>
        </Clamp>
      )}

      {/* no need to consider replacedPick before settlement */}
      {!isLive && !hasResult && selection.event.scheduledStartTime && (
        <Countdown
          scheduledStartTime={new Date(selection.event.scheduledStartTime)}
          selection={selection}
        />
      )}
      {<LiveClampWithStream isLive={isLive} selection={selection} />}
    </>
  );
};

export { PickClamp };
